<template>
  <div class="cart-list-components">
    <div v-if="cartList.length" class="selection notranslate">
      <span class="checkbox">
        <input type="checkbox" id="cart_check_all_top"
          v-model="checkedAll"
          @change="isCheckedAll">
        <label for="cart_check_all_top">{{locale.all}}</label>
      </span>
      <button type="button" class="btn btnRound sizeXs btnWhite toCapitalize" @click="deleteItem(checkedIds)">{{locale.delete}}</button>
    </div>
    <div class="list"
      :class="{multiCart: multiCart}">
      <div v-if="cartList.length">
        <div v-for="item in cartList"
          :key="item.cartId"
          class="cartItemWrapper">
          <!-- 장바구니상품-어메니티 -->
          <CartItemAmenity
            v-if="item.cartId.includes('amenity')"
            :lang="lang"
            :item="item"
            :locale="locale"
            :change="change"
            :multiCartAvailable="multiCartAvailable(item)"
            :setting="amenitySetting"
            :class="{first: item.first, last: item.last}"
            :multiCartTax="taxPrice(item.submitId)"
            :isFloating="isFloating"
            @checkedItem="checkedItem"
            @requestMultiCart="requestMultiCart"
            @deleteAmenity="deleteAmenity" />
          <!-- //장바구니상품-어메니티 -->
          <!-- 장바구니상품-샵(productV2) -->
          <CartShopItem
            v-else-if="item.cartId.includes('shop') && loadShopItem(item.shopItemId)"
            :locale="locale"
            :lang="lang"
            :item="item"
            :class="{first: item.first, last: item.last}"
            :isFloating="isFloating"
            @setQuantityShopItem="setQuantityShopItem"
            @requestMultiCart="requestMultiCart"
            @checkedItem="checkedItem"
            @delete="deleteItem"
            @isValidItem="isValidItem" />
          <!-- //장바구니상품-샵(productV2) -->

          <!-- 장바구니상품-기존 오더 -->
          <CartItem
            v-else-if="!(item.cartId.includes('amenity') || item.cartId.includes('shop'))"
            :lang="lang"
            :item="item"
            :locale="locale"
            :change="change"
            :multiCartAvailable="multiCartAvailable(item)"
            :submitCode="submitCode"
            :class="{first: item.first, last: item.last}"
            :multiCartTax="taxPrice(item.submitId)"
            :isFloating="isFloating"
            @setQuantityItem="setQuantityItem"
            @checkedItem="checkedItem"
            @requestMultiCart="requestMultiCart"
            @delete="deleteItem" />
          <!-- //장바구니상품-기존 오더 -->
        </div>
      </div>
      <div v-else class="cartItem noData notranslate">{{locale.cart_empty}}</div>
    </div>
    <div v-if="!multiCart && list.length" class="cartTotal notranslate">
      <div v-if="totalPrice" class="toCapitalize">
        <div v-if="taxPrice()">
          <div class="tax price">
            <span class="label">{{locale.subtotal}}</span>
            <span class="value">{{priceFormat(taxPrice().subtotal)}}</span>
          </div>
          <div class="tax price">
            <span class="label">{{locale.tax}}({{taxPrice().taxLabel}})</span>
            <span class="value">{{priceFormat(taxPrice().tax)}}</span>
          </div>
          <div class="price mb30">
            <span class="label">{{locale.total}}</span>
            <span class="value">{{priceFormat(taxPrice().total)}}</span>
          </div>
        </div>
        <div v-else class="price mb30">
          <span class="label">{{locale.total}}</span>
          <span class="value">{{priceFormat(totalPrice())}}</span>
        </div>
      </div>
      <div v-if="!isAuth" class="messages">
        <p v-if="!isAuth" class="validateMessage">{{locale.invalid_key}}</p>
      </div>
      <div class="btns">
        <button v-if="isFloating"
          type="button"
          class="btn btnRound btnDarkWhite toCapitalize btnClose"
          @click.stop="closeCart">
          {{locale.close_cart}}
        </button>
        <button  v-if="!possibleAmenity.isPossible"
          type="button"
          class="btn btnRound toCapitalize"
          disabled
          @click.stop="requestCart(null)">
          <span v-show="totalPrice() > 0" class="btn-price">{{priceFormat(totalPrice())}} / </span>
          {{locale.btn_request}}
        </button>
        <button v-else
          type="button"
          class="btn btnRound toCapitalize"
          :disabled="!checkedIds.length || !isAuth"
          :style="(checkedIds.length || !isAuth) && defaultBtnStyle"
          @click.stop="requestCart(null)">
          <span v-show="totalPrice() > 0" class="btn-price">{{priceFormat(totalPrice())}} / </span>
          {{confirmChanged ? locale.next_step : locale.btn_request}}
          </button>
      </div>
    </div>
    <UserInfo v-if="paymentUserInfo"
      :lang="lang"
      :locale="locale"
      :submitId="multicartSubmitId"
      @confirm="confirmPaymentUserInfo" />
    <div v-if="toastList">
      <Toast v-for="toast in toastList"
        :locale="locale"
        :key="toast.id"
        :toast="toast"
        @confirm="toastConfirm" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import CartItem from '@/components/Cart/CartItem'
import CartItemAmenity from '@/components/Cart/CartItemAmenity'
import CartShopItem from '@/components/Cart/CartShopItem'
import UserInfo from '@/components/Payment/UserInfo'
import Toast from '@/components/Util/Toast'

export default {
  name: 'CartList',
  props: [
    'lang',
    'locale',
    'isPublic',
    'responsive',
    'isFloating'
  ],
  components: {
    CartItem,
    CartItemAmenity,
    CartShopItem,
    UserInfo,
    Toast
  },
  computed: {
    ...mapGetters({
      getTax: 'payment/getTax',
      getAvailableDay: 'util/getAvailableDay'
    }),
    getOrderUserInfo () {
      const userInfo = this.$store.getters['payment/getUserInfo']
      if (!userInfo) return null

      const entries = Object.entries(userInfo)

      const defaultField = entries
        .filter(([key]) => !key.startsWith('custom'))
        .map(([id, value]) => ({ id, value }))

      const customField = entries
        .filter(([key]) => key.startsWith('custom'))
        .map(([id, value]) => ({ id, ...value }))

      return [...defaultField, ...customField]
    },
    getShopResultData () {
      return this.$store.getters['shop/getShopResultData']
    },
    defaultBtnStyle () {
      return this.$store.getters['common/getDefaultBtnStyle']
    },
    setting () {
      return this.$store.getters['common/getSetting']
    },
    tax () {
      return this.$store.state.payment.tax
    },
    multiCart () {
      return !this.isFloating && this.setting.order && this.setting.order.multiCart
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    currencyCode () {
      return this.setting.currency.toUpperCase()
    },
    checkableIds () {
      const site = this.$store.state.authentication.site
      const amenity = `cart_${site}_amenity`
      return this.cartList.filter(x => x.cartId === amenity || (x.isAvailable && x.isOpen)).map(x => x.cartId)
    },
    checkedIds () {
      return this.cartList.filter(x => x.isChecked).map(x => x.cartId)
    },
    cartList () {
      // return this.list.filter(x => !(x.removed))
      const Store = this.$store
      function getMultiCartPrice (arr, id, isShop) {
        if (isShop) {
          return arr.filter(x => x.shopPageId === id && x.isChecked).map(x => {
            return Store.getters['shop/getShopItemPrice'](x).total
          }).reduce((a, b) => a + b, 0)
        } else {
          return arr.filter(x => (x.submitId === id) && x.price && x.price.info && x.price.info.total && x.isChecked)
            .map(x => x.price.info.tax ? x.price.info.subtotal : x.price.info.total)
            .reduce((a, b) => a + b, 0)
        }
      }

      /**
       * 샵아이템만 해당
       * shopItemId 기준으로 묶고(그룹 순서는 첫 등장 순서),
       * 각 그룹 내부는 cartId가 같은 항목끼리만 연속으로 모은 뒤
       * 나머지 항목은 원래 배열 순서를 유지한다.
       * store/cart.js getters.getCartList에 동일한 코드 있음
       */
       function sortByShopItemThenGroupCartId(arr) {
        // 원본 보존을 위해 데코레이션
        const decorated = arr.map((item, idx) => ({ item, idx }))
      
        // 1) shopItemId 그룹핑 (첫 등장 순서 보존)
        const groupOrder = []
        const groups = new Map()
      
        for (let i = 0; i < decorated.length; i++) {
          const d = decorated[i]
          const hasShopId = Object.prototype.hasOwnProperty.call(d.item, 'shopItemId') && d.item.shopItemId != null
          const gkey = hasShopId ? `SID:${d.item.shopItemId}` : `SID#${i}` // 없으면 단독 그룹
      
          if (!groups.has(gkey)) {
            groups.set(gkey, [])
            groupOrder.push(gkey)
          }
          groups.get(gkey).push(d)
        }
      
        // 2) 그룹 내부에서 cartId 동일 항목끼리 연속 배치(원래 순서 유지)
        const out = []
        for (let gi = 0; gi < groupOrder.length; gi++) {
          const key = groupOrder[gi]
          const items = groups.get(key) // 원래 순서
      
          const cidOrder = []
          const buckets = new Map()
      
          for (let j = 0; j < items.length; j++) {
            const dj = items[j]
            const hasCid = Object.prototype.hasOwnProperty.call(dj.item, 'cartId') && dj.item.cartId != null
            const cidKey = hasCid ? `CID:${dj.item.cartId}` : `CID#${dj.idx}` // cartId 없으면 단독 버킷

            if (!buckets.has(cidKey)) {
              buckets.set(cidKey, [])
              cidOrder.push(cidKey)
            }
            buckets.get(cidKey).push(dj)
          }
      
          for (let k = 0; k < cidOrder.length; k++) {
            const bkey = cidOrder[k]
            const bucket = buckets.get(bkey)
            for (let t = 0; t < bucket.length; t++) out.push(bucket[t].item)
          }
        }
        return out
      }

      let list = this._.cloneDeep(this.list)
      const isMultiCart = this.multiCart
      list = sortByShopItemThenGroupCartId(list)
      if (isMultiCart) {
        list = list.sort((a, b) => {
          return (a.submitId || a.shopPageId) < (b.submitId || b.shopPageId) ? -1 : (a.submitId || a.shopPageId) > (b.submitId || b.shopPageId) ? 1 : 0
        }).map((x, i) => {
          const b = list[i + 1]
          const c = list[i - 1]
          const submitId = x.submitId || x.shopPageId
          if (!b || (b && (submitId !== (b.submitId || b.shopPageId)))) {
            x.last = true
            // x.multiCartAvailable = list.filter(d => d.submitId !== 'system_amenity' && d.submitId === submitId).filter(d => !d.isAvailable).length === 0
            // x.multiCartOpen = list.filter(d => d.submitId !== 'system_amenity' && d.submitId === submitId).filter(d => !d.isOpen).length === 0
            x.multiCartPrice = getMultiCartPrice(this.list, (x.submitId || x.shopPageId), x.shopPageId)
          }
          if (!c || (c && submitId !== (c.submitId || c.shopPageId))) {
            x.first = true
          }
          return x
        })
      }
      return list
    },
    priceInfo () {
      return (submitId) => this.cartList
        .filter(x => submitId
          ? x.isChecked && x.submitId === submitId && x.price && x.price.info !== null
          : x.isChecked && x.price && x.price.info !== null)
        .map(x => {
          return {
            ...x.price.info,
            quantity: x.changedInfo && x.changedInfo.qty > 0 ? x.changedInfo.qty : x.price.info.quantity,
            total: x.changedInfo && x.changedInfo.total > 0 ? x.changedInfo.total : x.price.info.total
          }
        })
    },
    totalPrice () {
      return (submitId) => {
        const isChange = this.change
        const checked = this.checkedIds
        const price = this.cartList.filter(x => checked.includes(x.cartId))
          .filter(x => submitId
            ? x.submitId === submitId && x.price && x.price.info !== null
            : x.price && x.price.info !== 0)
          .map(x => {
            return isChange && x.changedInfo
              ? x.changedInfo.total
              : x.price.info.tax
                ? x.price.info.subtotal
                : x.price.info.total
          })
        const sum = (accumulator, currentValue) => accumulator + currentValue
        const total = price && price.length ? price.reduce(sum, 0) : 0
        const shopPrice = this.cartList.filter(x => {
            return x.cartId.includes('shop') && checked.includes(x.cartId)
          }).map(x => {
            return this.$store.getters['shop/getShopItemPrice'](x).total
          })
        const shopPriceTotal = (shopPrice && shopPrice.reduce(sum, 0)) || 0
        return (price && total) + shopPriceTotal || 0
      }
    },
    taxPrice () {
      return (submitId) => {
        const total = this.totalPrice(submitId)
        const taxPer = this.tax
        const tax = this.getTax(total)
        const taxTotal = total + tax
        return taxPer
          ? {
            subtotal: total,
            tax: tax,
            taxLabel: `${taxPer}%`,
            total: taxTotal
          }
          : null
      }
    },
    activeUserInfo () {
      return this.$store.state.common.setting.order && this.$store.state.common.setting.order.disabled !== true
    },
    possibleAmenity () {
      const hasAmenity = this.list.find(x => x.submitId && x.submitId.includes('system_amenity'))
      const checkedAmenity = this.checkedIds.find(x => x.includes('amenity'))
      const setting = this.amenitySetting
      const itemLimit = setting && setting.itemLimitActive && setting.itemLimit
      const validItems = hasAmenity
        ? hasAmenity.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount && x.passedOrder
            : x.count > 0
        }).length
        : 0
      return {
        hasAmenity: hasAmenity,
        checkedAmenity: checkedAmenity,
        validItems: validItems,
        isPossible: hasAmenity && checkedAmenity && setting
          ? itemLimit
            ? itemLimit >= validItems
            : true
          : true,
        itemLimit: hasAmenity && setting
          ? itemLimit
          : null
      }
    },
    isUserinfo () {
      const inputs = this.$store.getters['common/getUserinfo']
      const isFirstName = inputs.firstName !== false
      const isLastName = inputs.lastName !== false
      const isTel = inputs.tel !== false
      const isEmail = inputs.email !== false
      const isCustom = inputs.custom && inputs.custom.length > 0
      return isFirstName || isLastName || isTel || isEmail || isCustom
    },
    getCartList () {
      return this.$store.getters['cart/getList']
    },
    shopItems () {
      return this.list && this.list.filter(x => this.checkedIds.includes(x.cartId) && x.cartId.includes('shop'))
    },
    shopPageIds () {
      const pageIds = this.list && this.list.filter(x => x.shopPageId).map(x => x.shopPageId)
      return pageIds && pageIds.length ? [...new Set(pageIds)] : null
    },
    // 현재 렌더 중인 아이템들 기준으로만 판단
    validAll () {
      const cartIds = (this.list || []).map(item => item.cartId)
      if (cartIds.length === 0) return false // 빈 장바구니면 주문불가
      // 아직 보고되지 않은 아이템은 true로 간주
      return cartIds.every(cartId => this.validityMap[cartId] === true)
    },
  },
  async mounted () {
    const site = this.$store.state.authentication.site
    this.$store.commit('loading', true)
    await this.getKey()
    await this.$store.dispatch('submit/getSystemCode').then((sysCode) => {
      this.$store.dispatch('submit/getUserCode').then((userCode) => {
        if (sysCode) {
          this.submitCode = this.submitCode.concat(sysCode)
        }
        if (userCode) {
          this.submitCode = this.submitCode.concat(userCode)
        }
      })
    })
    const ota = this.key
    if (localStorage.length > 0 && ota) {
      let delStorageIds = []
      for (let i = 0; i < localStorage.length; i++) {
        // cart_로 시작하는 items
        const storage = localStorage.key(i)
        if (storage.includes('cart_') && storage.includes(site)) {
          const cartItem = JSON.parse(localStorage.getItem(storage))
          let item = Object.assign({}, cartItem)
          item.cartId = localStorage.key(i)
          if (item.cartOta && item.cartOta === ota) {
            // 현재의 샵프로퍼티
            if (item.shopPageId) {
              await this.loadShop(item.shopPageId)
              const itemData = this.loadShopItem(item.shopItemId)
              item.payload = {
                ...item.payload,
                ...itemData && {
                  quantity: item.quantity > itemData.limit ? itemData.limit : item.payload.quantity,
                  selectQuantity: {
                    max: itemData.limit,
                    min: itemData.required
                  }
                }
              }
            }
            // 이용가능 시간 다시 불러옴
            if (item.pageId) {
              const productPage = item.productId && await this.$store.dispatch('product/getProduct', item.productId)
              const productPageItem = item.productItemId && productPage && productPage.items && productPage.items.find(x => x.id === item.productItemId)
              await this.$store.dispatch('page/loadPage', item.pageId).then((res) => {
                if (res.id) {
                  const availableTime = (productPageItem && productPageItem.available) || res.available
                  const isDisabled = (productPageItem && (productPageItem.disabled || !productPageItem.service)) || null
                  item.isOpen = res.state === '01'
                  item.info.available = availableTime
                  item.isChecked = !isDisabled && this.checkAvailableTime(availableTime)
                  item.isAvailable = !isDisabled && this.checkAvailableTime(availableTime)
                  item.isExist
                } else {
                  item.removed = true
                }
              })
            }
            if (item.productId) {
              item.isOpen = true
              // item.isChecked = this.checkAvailable(item.info.available) && item.price.info.quantity && item.price.info.quantity > 0
              // item.isAvailable = this.checkAvailable(item.info.available)
            }
            if (cartItem.content) {
              cartItem.content.forEach(function (x) {
                if (x.type === 'datetime') {
                  item.datetime = x
                } else if (x.type === 'quantity') {
                  item.quantity = x
                }
              })
            }
            if (item.content) {
              item.content = cartItem.content.filter(x => {
                return x.type !== 'datetime' && x.type !== 'quantity' && x.value !== null
              })
            }
            if (item.cartId === `cart_${site}_amenity`) {
              // 요청한 어메니티 히스토리 (제한이 있는 경우를 위한 정보 호출)
              await this.diffAmenity(item).then((res) => {
                this.checkOrderedAmenity(item).then((cartContent) => {
                  // if (cartContent.items.length <= 0) {
                  //   localStorage.removeItem(`cart_${site}_amenity`)
                  // } else {
                  //   localStorage.setItem(`cart_${site}_amenity`, JSON.stringify(cartContent))
                  // }
                })
              })
            }
            // 게스트타입 추가변동금액 적용
            if (item.guestTypePrice) {
              item.price.info = {
                ...item.price.info,
                ...item.productId && { // price: 단가, 페이지는 0일 수도 있음, 전송시 백엔드에서 필요해서 페이지 연결된 상품인 경우 넣음
                  price: item.guestTypePrice.price,
                  total: item.guestTypePrice.total
                }
              }
            }
            if (item.productId && (item.productId.includes('undefined') || item.removed)) {
              localStorage.removeItem(storage)
              this.$store.commit('cart/delList', item.cartId)
            } else {
              this.$store.commit('cart/addList', item)
              this.list.push(item)
            }
            if (item.cartId.includes('shop')) {
              item.isChecked = true
            }
          } else {
            delStorageIds.push(storage)
          }
        }
        if (i === localStorage.length - 1) {
          this.list.sort((a, b) => parseFloat(Number(b.order)) - parseFloat(Number(a.order)))
          this.diffManageProduct()
          this.loadProduct()
          await this.checkShop()
        }
      }
      if (delStorageIds && delStorageIds.length) {
        for (let i = 0; i < delStorageIds.length; i++) {
          const storage = delStorageIds[i]
          this.$store.commit('cart/delList', storage)
        }
      }
    }
    this.$store.commit('loading', false)
  },
  data () {
    return {
      list: [],
      checkedAll: true,
      payment: null,
      confirmChanged: false,
      manageList: [],
      change: false,
      paymentUserInfo: null,
      submitCode: [],
      amenitySetting: {},
      isAuth: false,
      key: this.$store.state.authentication.k,
      checkAvailable: 0,
      multicartSubmitId: null,
      toastList: [],
      validityMap: Object.create(null),
    }
  },
  methods: {
    isValidItem (cartId, isValid) {
      if (!Object.prototype.hasOwnProperty.call(this.validityMap, cartId)) {
        this.$set(this.validityMap, cartId, !!isValid)
      } else {
        this.validityMap[cartId] = !!isValid
      }
    },
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
      this.checkAuth()
    },
    checkAuth () {
      const getAuthInfo = this.$store.getters['authentication/getAuthInfo']
      const key = this.key
      const space = getAuthInfo.space
      const hasKey = !!key && key !== 'undefined'
      const hasSpace = !!space && space !== 'undefined'
      const isKeyValid = !(getAuthInfo.otavalid && getAuthInfo.otavalid === 'false')
      this.isAuth = hasKey && hasSpace && isKeyValid
    },
    isCheckedAll () {
      const isCheckedAll = this.checkedAll
      const checkableIds = this.checkableIds
      this.list = this.list.map(x => {
        const checked = !x.isAvailable ? false : isCheckedAll && checkableIds.includes(x.cartId) && !x.isDisabled
        return {
          ...x,
          isChecked: checked
        }
      })
    },
    checkAvailableTime (data) {
      let isAvailable = true
      const available = data // submit 데이터
      const isAlways = available.state === '01' // 01 ? always : each
      const today = moment().isoWeekday() - 1
      const day = available.set[today]
      const check = this.getAvailableDay(day)
      isAvailable = isAlways
        ? true
        : check
      return isAvailable
    },
    get1dayOrders (iso) {
      const timezone = this.timezone
      const time = this.amenitySetting.limitTime || '12:00' // 설정한 리셋시간
      const hh = time.split(':')[0]
      const mm = time.split(':')[1]
      const today = moment().set({ hour: hh, moment: mm, second: 0 }).tz(timezone).toISOString()
      const tomorrow = moment().set({ hour: hh, moment: mm, second: 0 }).add(1, 'days').tz(timezone).toISOString()
      return moment(iso).tz(timezone).isBetween(today, tomorrow)
    },
    priceFormat (price) {
      const currency = this.$store.getters['shop/getShopCurrency'] || null
      return this.$store.getters['util/getPriceFormatter'](price, currency)
    },
    displayPrice (price) {
      const currency = this.$store.state.common.setting.currencyEntity
      return `${currency} ${regExp.comma(price)}`
    },
    deleteItem (cartIds) {
      if (this.responsive === 'tablet' && (this.$route.name.includes('product') || this.$route.name.includes('shop'))) {
        this.deleteCart(cartIds)
      } else {
        this.addToast('deleteCartItem', 'confirm', this.locale.confirm_cart_delete, { otherData: { cartIds: cartIds } })
      }
    },
    deleteCartItem (cartIds) {
      this.deleteCart(cartIds)
    },
    deleteAmenity (raCode) {
      if (this.responsive === 'tablet' && this.$route.name.includes('product')) {
        this.deleteCartAmenity(raCode)
      } else {
        this.addToast('deleteAmenityItem', 'confirm', this.locale.confirm_cart_delete, { otherData: { raCode: raCode } })
      }
    },
    deleteAmenityItem (raCode) {
      this.deleteCartAmenity(raCode)
    },
    deleteCartAmenity (raCode) {
      const Store = this.$store
      const siteId = Store.state.authentication.site
      const cartId = `cart_${siteId}_amenity`
      const cartAmenity = this.list.find(x => x.cartId === cartId)
      if (cartAmenity.items.length > 0 || (cartAmenity.content && cartAmenity.content.length > 0)) {
        cartAmenity.items = cartAmenity.items.filter(x => x.item !== raCode)
        if (cartAmenity.content) {
          cartAmenity.content = cartAmenity.content.filter(x => x.label !== raCode)
        }
        if (cartAmenity.price) {
          const items = cartAmenity.items.filter(x => x.price)
          const total = items && items.length ? items.map(x => x.price * x.count).reduce((a, b) => a + b) : 0
          cartAmenity.price = {
            info: {
              ...cartAmenity.price.info,
              sum: total,
              total: total
            },
            option: items
          }
        }
        localStorage.setItem(cartId, JSON.stringify(cartAmenity))
        if (cartAmenity.items.length === 0 || (cartAmenity.content && cartAmenity.content.length === 0)) {
          this.list = this.list.filter(x => x.cartId !== cartId)
          localStorage.removeItem(cartId)
        }
      } else {
        this.list = this.list.filter(x => x.cartId !== cartId)
        localStorage.removeItem(cartId)
      }
      Store.commit('cart/delAmenity', raCode)
      if (!(this.responsive === 'tablet' && (this.$route.name.includes('product') || this.$route.name.includes('shop')))) {
        this.addToast('closeToast', 'alert', this.locale.complete_delete)
      }
    },
    deleteCart (cartIds) {
      const Store = this.$store
      cartIds.forEach(function (cartId, index) {
        localStorage.removeItem(cartId)
        Store.commit('cart/delList', cartId)
        return index + 1 === cartIds.length
      })
      this.list = this.list.filter(x => !cartIds.includes(x.cartId))
      this.checkedAll = false
      if (!(this.responsive === 'tablet' && (this.$route.name.includes('product') || this.$route.name.includes('shop')))) {
        this.addToast('closeToast', 'alert', this.locale.complete_delete)
      }
    },
    loadShopItem (shopItemId) {
      return this.$store.getters['cart/getCartShopItems'](shopItemId)
    },
    async loadShop (shopPageId) {
      const data = {
        shopPageId: shopPageId
      }
      // 최신 버전
      const getLastVersion = await this.$store.dispatch('shop/getLastVersion', data.shopPageId)
      const version = getLastVersion && getLastVersion.message && getLastVersion.message.last_version
      // 인덱스디비에 있는지, 최신 버전인지
      const indexedData = await this.$store.dispatch('versionhistory/getIndexedDb', {
        table: 'shop',
        id: data.shopPageId,
        version: version || 0
      })
      // 버전이 다르거나 인덱스디비에 없으면 샵프로퍼티 호출 아니면 인덱스 데이터 리턴
      const res = (!indexedData || indexedData === 'diffVersion')
        ? await this.$store.dispatch('shop/getOrderPageProperty', data)
        : indexedData
      const property = (!indexedData || indexedData === 'diffVersion')
        ? res && res.property
        : indexedData
      if (property) {
        if (property.shopItemsProperty) {
          // this.$store.commit('shop/setItemProperty', property.shopItemsProperty)
          this.$store.dispatch('shop/ingestItemProperty', property.shopItemsProperty)
        }
        if (property.pageData && property.pageData.settings) {
          this.$store.commit('shop/setShopSettings', {
            shopPageId: data.shopPageId,
            settings: {
              ...property.pageData.settings,
              ...property.pageData.currencyCode && {
                currencyCode: property.pageData.currencyCode
              },
              ...property.pageData.guestSettings && {
                guestSettings: property.pageData.guestSettings
              },
              ...property.pageData.orderLimitSetting && {
                orderLimitSetting: property.pageData.orderLimitSetting
              },
              isUseCallStaff: property.pageData.isUseCallStaff === true
            }
          })
        }
      }
    },
    async checkOrderedAmenity (item) {
      const cartContent = {
        ...item,
        items: item.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount && x.passedOrder
            : x.count > 0
        }).map(x => {
          return {
            count: x.count,
            item: x.item,
            ...x.price && {
              price: x.price,
              quantity: x.quantity
            }
          }
        })
      }
      return cartContent
    },
    async loadProduct () {
      const products = new Set(this.list.filter(x => !x.pageId && x.productId && x.productItemId).map(x => x.productId))
      const productIds = [...products]
      if (!productIds.length) return
      for (let i = 0; i < productIds.length; i++) {
        const id = productIds[i]
        const itemIds = this.list.filter(x => !x.pageId && x.productItemId && x.productId && x.productId === id).map(x => x.productItemId)
        await this.$store.dispatch('product/getProduct', id).then((res) => {
          for (let j = 0; j < itemIds.length; j++) {
            const itemId = itemIds[j]
            const item = this.list.find(x => x.productId && x.productId === id && x.productItemId === itemId)
            const resItem = res.items.find(x => x.id === itemId)
            if (item && resItem) {
              const itemQuantity = item.price.info.quantity > resItem.info.max
                ? resItem.info.max
                : item.price.info.quantity < resItem.info.min
                  ? resItem.info.min
                  : item.price.info.quantity
              // const itemTotal = 
              item.isDisabled = resItem.disabled || !resItem.service || !resItem.submitTo
              item.isChecked = this.checkAvailableTime(resItem.available) && (item.pageId ? true : item.price.info.quantity && item.price.info.quantity > 0) && !item.isDisabled
              item.isAvailable = this.checkAvailableTime(resItem.available)
              item.info.available = resItem.available
              item.isExist = true // 현재 있는 아이템임
              item.info.min = resItem.info.min
              item.info.max = resItem.info.max
              item.price.info = {
                ...item.price.info,
                quantity: itemQuantity,
                total: item.price.info.sum + item.price.info.price * itemQuantity
              }
              if (item.quantity && item.quantity.value) {
                item.quantity.value = item.price.info
              }
            }
          }
        })
      }
    },
    async diffAmenity (item) {
      function getOrderList (arr) {
        let result = []
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i]
          if (item.ordersheet.length) {
            for (let j = 0; j < item.ordersheet.length; j++) {
              const ordersheet = item.ordersheet[j]
              result.push({ ...ordersheet, date: item.date })
            }
          } else {
            result.push({ ...item.ordersheet, date: item.date })
          }
        }
        return result
      }
      function getCount (max, count) {
        return max - count <= 0 ? 0 : max - count
      }
      let orderedAmenity = null
      await this.$store.dispatch('submit/getOrderHistory').then((oredered) => {
        if (oredered && oredered.orderLog) {
          const orders = oredered.orderLog.filter(x => {
            return x.order_type && x.order_type.includes('system_amenity')
          }).map(x => {
            return {
              ordersheet: x.ordersheet,
              date: x.createat
            }
          })
          orderedAmenity = getOrderList(orders)
        }
      })
      await this.$store.dispatch('amenity/getAmenity').then((res) => {
        const setting = res.setting
        const isIntegration = setting && setting.integration
        const isAvailable = setting && setting.available ? this.checkAvailableTime(setting.available) : true
        this.amenitySetting = setting
        item.items = item.items.map(x => {
          const amenityItem = res.list.find(a => a.raCode === x.item)
          const orderedItems = orderedAmenity ? orderedAmenity.filter(i => {
            return i.items && i.items.length && i.items.find(f => f.item === x.item)
          }) : []
          const itemMax = amenityItem && isIntegration && amenityItem.orderLimitActive && !(x.price && parseFloat(x.price) >= 0) // 요청가능 수량
            ? amenityItem.orderLimit === 'day'
              ? getCount(amenityItem.max, orderedItems.filter(o => this.get1dayOrders(o.date)).map(o => o.items).flat().filter(o => o.item === x.item).map(o => o.count).reduce((a, b) => a + b, 0)) // 1일 제한
              : getCount(amenityItem.max, orderedItems.map(o => o.items).flat().filter(o => o.item === x.item).map(o => o.count).reduce((a, b) => a + b, 0)) // 투숙기간 제한
            : amenityItem.max
          const count = amenityItem // 최종 요청할 수량 조정
            ? x.count > itemMax
              ? itemMax // 어메니티 최대요청수량보다 많을 수 없음
              : x.count
            : x.count
          const countChanged = x.count > itemMax
          const orderCount = amenityItem && isIntegration && amenityItem.orderLimitActive // 요청 가능한 횟수
            ? amenityItem.orderLimit === 'day'
              ? getCount(amenityItem.orderMax, orderedItems.filter(o => this.get1dayOrders(o.date)).length)
              : getCount(amenityItem.orderMax, orderedItems.length)
            : null
          return {
            ...x,
            count: count,
            disabled: amenityItem.disabled || !amenityItem.service, // 일시중단 또는 서비스하지 않음
            ...countChanged && {
              countChanged: true
            },
            ...isIntegration && amenityItem.orderLimitActive && !x.price && {
              orderLimit: amenityItem.orderLimit,
              orderMax: amenityItem.orderMax,
              orderCount: orderCount,
              passedCount: count > 0, // 요청 개수가 유효?
              passedOrder: orderCount > 0 // 요청 횟수가 유효?
            }
          }
        })
        if (isIntegration && item.price) {
          const priceOption = item.items.filter(x => x.price)
          const total = priceOption.length > 0 ? item.items.filter(x => x.price).map(x => x.price * x.count).reduce((a, b) => a + b) : 0
          item.price = {
            info: {
              ...item.price.info,
              sum: total,
              total: total,
              ...this.tax && {
                tax: this.getTax(total),
                subtotal: total,
                total: total + this.getTax(total)
              }
            },
            option: item.items.filter(x => x.price)
          }
        }
        item.isAvailable = item.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount && x.passedOrder
            : x.count > 0
        }).length > 0 && isAvailable
        item.isChecked = item.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount && x.passedOrder
            : x.count > 0
        }).length > 0 && isAvailable
        // item.isExist = item.items.filter(x => !x.disabled).length > 0
      })
      return item
    },
    async diffManageProduct (order) { // order: 주문 직전 체크 (isChecked를 마음대로 단정할 수 없음)
      if (!this.list.find(x => x.productId)) return
      const res = await this.$store.dispatch('product/getManageProduct')
      this.manageList = res
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i]
        const pid = item.pId
        const manageItem = this.manageList.find(x => x.pid === pid)
        const infoA = item.price ? item.price.info : null
        const infoB = manageItem
        // 관리상품 처리
        if (item.manage && manageItem) {
          if (infoA.quantity !== infoB.qty) {
            // 재고수량 없음
            if (infoB.qty === 0) {
              item.changedInfo = {
                initQty: infoA.initQuantity || infoA.quantity,
                qty: infoB.qty,
                total: infoB.qty * infoA.price
              }
              item.isChecked = false
            // 재고수량이 신청수량보다 적음
            } else if (infoB.qty < infoA.quantity) {
              item.changedInfo = {
                initQty: infoA.initQuantity || infoA.quantity,
                qty: infoB.qty,
                total: infoB.qty * infoA.price
              }
            // 일시품절이었다가 재고 추가됨
            } else if (infoA.quantity === 0 && infoB.qty > 0) {
              const rQty = infoA.initQuantity < infoB.qty ? infoA.initQuantity : infoB.qty
              const rTotal = infoA.initQuantity < infoB.qty ? infoA.initQuantity * infoA.price : infoB.qty * infoA.price
              item.changedInfo = {
                initQty: infoA.initQuantity || infoA.quantity,
                qty: rQty,
                total: rTotal
              }
            }
          }
          infoB.qty = infoB.qty - (infoA.quantity) > 0 ? infoB.qty - (infoA.quantity) : 0
        }
      }
      if (!this.confirmChanged && this.list.filter(x => x.changedInfo).length) {
        this.addToast('closeToast', 'alert', `${this.locale.product_qty_changed_1}\n${this.locale.product_qty_changed_2}`)
        this.change = true
        // 장바구니 새로고침시 변경된 수량으로 정보 교체
        this.list.forEach(function (xx) {
          if (xx.manage && xx.changedInfo) {
            const cartId = xx.cartId
            const priceInfo = {
              ...xx.price.info,
              quantity: xx.changedInfo.qty,
              initQuantity: xx.changedInfo.initQty,
              total: xx.changedInfo.total
            }
            const cartContent = {
              ...xx,
              price: {
                ...xx.price,
                info: priceInfo
              },
              ...xx.guestTypePrice && {
                guestTypePrice: xx.guestTypePrice
              }
            }
            delete cartContent.changedInfo
            localStorage.setItem(cartId, JSON.stringify(cartContent))
          }
        })
        this.confirmChanged = true
        return true
      } else {
        // 일시품절 상품 체크해제
        this.list = this.list.map(x => {
          return {
            ...x,
            isChecked: x.manage
              ? order ? x.isChecked : x.price.info.quantity > 0 && x.price.info.total > 0
              : order ? x.isChecked : x.submitId && x.submitId.includes('system_amenity')
                ? this.amenitySetting && this.amenitySetting.itemLimitActive
                  ? (x.items.length <= this.amenitySetting.itemLimit) && x.isAvailable
                  : x.items.filter(i => i.passedCount !== false && i.passedOrder !== false).length > 0 && x.isAvailable
                : x.isAvailable
          }
        })
        return false
      }
    },
    requestMultiCart (submitId, shopPageId) {
      this.multicartSubmitId = submitId
      if (submitId) {
        if (submitId === 'system_amenity') {
          this.requestCart(submitId)
        } else {
          this.checkManageProduct(submitId)
        }
      } else if (shopPageId) {
        this.onSubmit(null, shopPageId)
      }
    },
    requestCart (submitId) {
      const amenityItem = this.list.find(x => x.submitId === 'system_amenity')
      this.$store.commit('loading', true)
      if (amenityItem) {
        this.diffAmenity(amenityItem).then((res) => {
          const items = res.items.filter(x => !x.disabled).filter(x => {
            return x.orderLimit
              ? x.passedCount && x.passedOrder
              : x.count > 0
          }).length
          const itemLimit = this.possibleAmenity.itemLimit
          const isValid = itemLimit ? itemLimit >= items : items > 0
          this.$store.commit('loading', false)
          if (submitId === 'system_amenity') {
            if (!isValid) {
              this.addToast('closeToast', 'alert', this.locale.alert_invalid_amenity_item)
            } else {
              this.checkManageProduct(submitId)
            }
          } else {
            this.checkManageProduct(submitId)
          }
        })
      } else {
        this.$store.commit('loading', false)
        this.checkManageProduct(submitId)
      }
    },
    async checkShop () {
      const shopItemList = this.list.filter(x => x.cartId.includes('cart_shop')) || []
      // 샵 아이템 프로퍼티 호출
      const shopPageItems = shopItemList.map(x => x.shopPageId)
      const shopPageIds = [...new Set(shopPageItems)]
      const itemsAll = await Promise.all(
        shopPageIds.map(async shopPageId => {
          const getShopPageProperty = await this.getShopPageProperty(shopPageId)
          return getShopPageProperty
        })
      )
      // 샵 아이템별 프리셋 호출
      const presetIds = extractUniqueValues(itemsAll)
      function extractUniqueValues (data) {
        const result = new Set()
        data.forEach(obj => {
          Object.values(obj).forEach(item => {
            if (item.promotion) result.add(item.promotion)
            if (item.availableTime) result.add(item.availableTime)
            if (item.status) result.add(item.status)
          })
        })
        return Array.from(result)
      }
      if (presetIds && presetIds.length > 0) {
        try {
          const res = await this.$store.dispatch('shop/getStorePresetItems', presetIds)
          const presetItem = res && res.message && res.message.presetItem
          if (presetItem) {
            this.$store.commit('shop/setPreset', presetItem)
          }
        } catch (ex) {
          return false
        }
      }
    },
    async getShopPageProperty (shopPageId) {
      try {
        const res = await this.$store.dispatch('shop/getOrderPageProperty', { shopPageId: shopPageId })
        const property = res && res.property
        if (property.catCode) {
          this.$store.commit('shop/setCatCodes', { shopPageId: shopPageId, catCode: property.catCode })
        }
        if (property && property.shopItemsProperty) {
          await this.$store.dispatch('shop/ingestItemProperty', property.shopItemsProperty)
        }
        if (property.pageData && property.pageData.settings) {
          this.$store.commit('shop/setShopSettings', {
            shopPageId: shopPageId,
            settings: {
              ...property.pageData.settings,
              ...property.pageData.guestSettings && {
                guestSettings: property.pageData.guestSettings
              },
              ...property.pageData.orderLimitSetting && {
                orderLimitSetting: property.pageData.orderLimitSetting
              },
              isUseCallStaff: property.pageData.isUseCallStaff === true
            }
          })
        }
        return property.shopItemsProperty
      } catch (error) {
        console.error(`Error loading property for ${shopPageId}`, error)
      }
    },
    // shop(product v2) items check billing
    async checkOrderStatus () {
      /**
       * 주문하려는 상품의 shopPageId별 빌링(포스결제)이 발생했는지 체크
       * 발생이 되었다면 해당 ota는 만료처리 되기 때문에
       * 새로운 ota로 주문까지 계속 진행해야 한다
       * 이 케이스는 pos연동시에만 관계가 있으므로 연동되지 않는 환경에서는 불필요함(무조건200ok)
       */
      const shopPageIds = this.shopPageIds
      if (!shopPageIds) return true
      try {
        const res = await Promise.all(
          shopPageIds.map(data => this.$store.dispatch('order/checkOrderStatus', data))
        )
        const result = res.map(r => r.result || r.status)
        const reqOta = result.find(x => x.newOTAKey)
        const errorItem = result.find(e => e && e.code)
        const errors = errorItem && this.getShopResultData(errorItem.code || 500)
        if (errors) {
          alert(`${errors}\n${errorItem.reason}`)
          return false
        } else {
          return reqOta || true
        }
      } catch (error) {
        console.log(error)
        const errors = error && this.getShopResultData(error.code || 500)
        alert(`${errors}\n${errors.reason}`)
        return false
      } finally {
      }
    },
    // shop(product v2) items submit
    async submitShopItems () {
      /**
       * payload 아이템 데이터 중
       * 다국어 객체 찾아 번역에 사용하는 값만 남기고 삭제
       */
      const excludeLangs = this.$store.getters['util/excludeLangs']
      const deepFilter = (data) => {
        const filterLangs = /name|shopItemName/
        if (Array.isArray(data)) {
          return data.map(deepFilter)
        } else if (data && typeof data === 'object') {
          return Object.entries(data).reduce((acc, [key, value]) => {
            acc[key] = filterLangs.test(key) && typeof value === 'object'
              ? excludeLangs(value)
              : deepFilter(value)
            return acc
          }, {})
        }
        return data
      }
      const shopItems = this.shopItems.map(x => {
        const filteredPayload = {
          pageId: x.shopPageId,
          priceInfo: {
            gross: '0'
          },
          ...deepFilter(x.payload)
        }
        return {
          ...x,
          payload: filteredPayload
        }
      })
      /**
       * catCode별로 payload에 묶어서
       * 그룹별로 전송 요청
       */
       const groupByCatCode = (items) => {
        return Object.values(
          items.reduce((acc, { catCode, payload }) => {
            if (!acc[catCode]) {
              acc[catCode] = { catCode, payload: [] }
            }
            acc[catCode].payload.push(payload)
            return acc
          }, {})
        )
      }
      const submitData = groupByCatCode(shopItems)
      const orderUserInfo = this.getOrderUserInfo

      try {
        const res = await Promise.all(
          submitData.map(data => this.$store.dispatch('order/setSubmit', {
            data: data,
            ...orderUserInfo && {
              orderUserInfo: orderUserInfo
            }
          }))
        )
        const result = (res && res.map(r => r.result)) || []
        const errorItem = result.find(e => e && e.code)
        const errors = errorItem && this.getShopResultData(errorItem.code || 500)
        if (errors) {
          this.$emit('setToastMessage', this.locale[errors], 5000)
          return null
        }
        return result
      } catch (e) {
        console.error('[submitShopItems error]', e)
        return false
      } finally {
      }
    },
    // 재고수량 체크
    async checkManageProduct (submitId) {
      if (this.confirmChanged) {
        this.setOutOfStock()
        if (this.activeUserInfo && this.isUserinfo) {
          this.paymentUserInfo = true
        } else {
          this.onSubmit(submitId)
        }
      } else {
        await this.diffManageProduct(true).then((res) => {
          if (res) {
            this.confirmChanged = true
          } else {
            this.setOutOfStock()
            if (this.activeUserInfo && this.isUserinfo) {
              this.paymentUserInfo = true
            } else {
              this.onSubmit(submitId)
            }
          }
        })
      }
    },
    // 수량없는 상품 체크에서 제외
    setOutOfStock () {
      this.list = this.list.map(x => {
        const outOfStock = x.changedInfo && x.changedInfo.qty <= 0
        return {
          ...x,
          isChecked: outOfStock ? false : x.isChecked
        }
      })
    },
    checkedItem (data) {
      const item = this.list.find(x => x.cartId === data.cartId)
      if (item) {
        this.list = this.list.map(x => {
          const isItem = x.cartId === data.cartId
          return {
            ...x,
            isChecked: isItem ? data.isChecked : x.isChecked
          }
        })
      }
    },
    setQuantityItem (data) {
      const item = this.list.find(x => x.cartId === data.cartId)
      const guestTypePrice = item && item.guestTypePrice
      item.quantity.value.quantity = data.quantity
      item.quantity.value.total = item.quantity.value.sum + item.quantity.value.price * data.quantity
      item.price.info = item.quantity.value
      if (guestTypePrice) {
        item.guestTypePrice.quantity = data.quantity
        item.guestTypePrice.total = guestTypePrice.price * data.quantity
      }
    },
    setQuantityShopItem (cartId, quantity) {
      const item = this.list.find(x => x.cartId === cartId)
      item.payload.quantity = quantity
    },
    multiCartAvailable (item) {
      const submitId = item.submitId
      if (item.cartId.includes('amenity')) {
        const itemLimit = this.amenitySetting && this.amenitySetting.itemLimitActive && this.amenitySetting.itemLimit
        const items = item.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount && x.passedOrder
            : x.count > 0
        }).length
        return itemLimit ? items > 0 && itemLimit >= items : items > 0
      } else if (item.last) {
        const group = this.cartList.filter(x => x.submitId === submitId)
        const isChecked = group.filter(x => x.isChecked)
        const isDisabled = group.filter(x => x.isChecked && !x.isAvailable)
        return isChecked.length > 0 && isDisabled.length === 0
      } else {
        return null
      }
    },
    addToast (trigger, type, message, otherData) {
      const id = UNIQUE.mid()
      const toast = {
        id: id,
        type: type,
        trigger: trigger,
        message: message,
        ...otherData
      }
      this.toastList.push(toast)
    },
    delToast (id) {
      this.toastList = id ? this.toastList.filter(x => x.id !== id) : []
    },
    toastConfirm (data) {
      const trigger = this.toastList.find(x => x.id === data.id) ? this.toastList.find(x => x.id === data.id).trigger : null
      if (!data.isConfirm) {
        this.delToast(data.id)
      } else {
        if (trigger) {
          if (trigger === 'confirmRequest') {
            this.confirmRequest(data.otherData.submitId, data.otherData.shopPageId)
          } else if (trigger === 'deleteCartItem') {
            this.deleteCartItem(data.otherData.cartIds)
          } else if (trigger === 'deleteAmenityItem') {
            this.deleteAmenityItem(data.otherData.raCode)
          } else if (trigger === 'closeToast') {
            this.delToast()
          }
        } else {
          alert(this.locale.alert_system_error)
        }
      }
    },
    confirmPaymentUserInfo (confirm) {
      const submitId = this.multicartSubmitId
      if (confirm) {
        this.onSubmit(submitId)
      } else {
        this.paymentUserInfo = null
      }
    },
    closeCart () {
      this.$emit('closeCart')
    },
    onSubmit (submitId, shopPageId) { // 멀티카트로 전송할 전송코드 또는 샵페이지id
      const lang = this.lang
      const submitIds = [...new Set(this.cartList.filter(x => x.isChecked).map(x => x.submitId))]
      const submitAmenity = this.cartList.find(x => x.submitId === 'system_amenity' && x.isChecked)
      const submitAmenityList = submitAmenity ? {
        ...submitAmenity,
        items: submitAmenity.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount !== false && x.passedOrder !== false
            : x.count > 0
        }).map(x => {
          return {
            count: x.count,
            item: x.item,
            ...x.price && { price: x.price },
            ...x.quantity && { quantity: x.quantity },
            ...x.pid && { pid: x.pid }
          }
        })
      } : null
      const submitAmenityV2 = this.cartList.find(x => x.submitId === 'system_amenity_v2' && x.isChecked)
      const submitAmenityV2List = submitAmenityV2
        ? submitAmenityV2.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount !== false && x.passedOrder !== false
            : x.count > 0
        }).map(x => {
          return {
            count: x.count,
            item: x.item,
            label: x.item,
            value: x.count,
            ...x.label && { label: x.label },
            ...x.price && { price: x.price },
            ...x.quantity && { quantity: x.quantity },
            ...x.pid && { pid: x.pid }
          }
        })
        : []
      /**
      * 멀티카트로 요청하면 해당 submitId만 묶어서 요청
      * 아닌경우(default) 체크박스
      */
      const submitAmenityItems = submitAmenity ? submitAmenity.items.filter(x => !x.disabled).map(x => {
        return {
          count: x.count,
          item: x.item,
          ...x.price && { price: x.price },
          ...x.quantity && { quantity: x.quantity }
        }
      }) : []
      const submitDataList = this.cartList
        .filter(x => !x.cartId.includes('shop'))
        .filter(x => typeof (submitId) === 'string' ? x.submitId === submitId && x.isChecked : x.isChecked)
        .map(x => {
          return x.submitId === 'system_amenity'
            ? submitAmenity
              ? {
                ...submitAmenity,
                items: submitAmenityItems
              }
              : null
            : {
              ...x,
              title: x.title,
              pId: x.pId || null,
              cartId: x.cartId || null,
              pageId: x.pageId || null,
              productId: x.productId || null,
              productItemId: x.productItemId || null,
              submitAt: moment().toISOString(),
              submitId: x.submitId,
              catCode: x.submitId,
              info: x.info,
              categoryLabel: x.categoryLabel || null,
              content: x.submitContent,
              price: {
                ...x.price,
                info: {
                  ...x.price.info,
                  quantity: x.changedInfo ? x.changedInfo.qty : x.price.info.quantity,
                  total: x.changedInfo ? x.changedInfo.total : x.price.info.total
                }
              },
              ...(submitAmenityV2 && x.submitId === 'system_amenity_v2') && {
                content: submitAmenityV2List,
                items: submitAmenityV2List
              },
              ...x.place && {
                place: x.place,
                placeName: x.place[lang]
              },
              ...x.pickup && {
                pickup: x.pickup,
                ...x.pickup === 'auto' && {
                  pickupTime: x.pickupTime
                }
              }
            }
        })
      const submitDataAll = submitIds.map(id => {
        return {
          isArray: true,
          submitId: id,
          submitArr: submitDataList.filter(x => x.submitId === id).concat([submitAmenityList])
        }
      })
      this.paymentUserInfo = null
      this.multicartSubmitId = null
      if (!submitDataAll.filter(x => x.submitArr.length).length) {
        this.addToast('closeToast', 'alert', this.locale.product_request_nodata)
      } else {
        this.addToast('confirmRequest', 'confirm', this.locale.confirm_request, { otherData: { submitId: submitId, shopPageId: shopPageId } })
      }
    },
    async confirmRequest (submitId, shopPageId) {
      this.$store.commit('loading', true)
      const lang = this.lang
      const shopIds = submitId ? [] : this.cartList.filter(x => (shopPageId ? x.shopPageId === shopPageId : true) && x.isChecked && x.cartId.includes('shop')) // 멀티카트 샵아이템이면 같은 shopPageId, 멀티카트 다른전송코드면 false, 아니면 true
      const submitIds = shopPageId ? [] : [...new Set(this.cartList.filter(x => !x.cartId.includes('shop')).map(x => x.submitId))]
      const submitAmenity =  shopPageId ? null : this.cartList.find(x => x.submitId === 'system_amenity')
      const submitAmenityList = shopPageId ? [] : submitAmenity ? {
        ...submitAmenity,
        items: submitAmenity.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount !== false && x.passedOrder !== false
            : x.count > 0
        }).map(x => {
          return {
            count: x.count,
            item: x.item,
            ...x.price && { price: x.price },
            ...x.quantity && { quantity: x.quantity },
            ...x.pid && { pid: x.pid }
          }
        })
      } : null
      const submitAmenityV2 = this.cartList.find(x => x.submitId === 'system_amenity_v2')
      const submitAmenityV2List = shopPageId ? [] : submitAmenityV2
        ? submitAmenityV2.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount !== false && x.passedOrder !== false
            : x.count > 0
        }).map(x => {
          return {
            count: x.count,
            item: x.item,
            label: x.item,
            value: x.count,
            ...x.label && { label: x.label },
            ...x.price && { price: x.price },
            ...x.quantity && { quantity: x.quantity },
            ...x.pid && { pid: x.pid }
          }
        })
        : []
      /**
      * 멀티카트로 요청하면 해당 submitId만 묶어서 요청
      * 아닌경우(default) 체크박스
      */
      const submitAmenityItems = shopPageId ? [] : submitAmenity ? submitAmenity.items.filter(x => !x.disabled).map(x => {
        return {
          count: x.count,
          item: x.item,
          ...x.price && { price: x.price },
          ...x.quantity && { quantity: x.quantity }
        }
      }) : []
      const submitDataList = shopPageId ? [] : this.cartList
        .filter(x => !x.cartId.includes('shop'))
        .filter(x => typeof (submitId) === 'string' ? x.submitId === submitId && x.isChecked : x.isChecked)
        .map(x => {
          /**
           * 상품의 경우 페이지 submit의 옵션에 붙는 pId 데이터와
           * 동일한 구조로 pIdInfo 맵핑
           * (포스로 전달 등을 위해 옵션 pId만 따로 맵핑하여 저장하는 용도)
           */
          const priceInfo = x.price.info
          const pIdItems = (x.productId && !x.pageId) && x.pId && x.pId.length > 0 ? [{
            index: 0,
            label: x.info.subject,
            pId: x.pId,
            pIdType: x.pIdType,
            pIdActive: true,
            pIdType: x.pIdType,
            price: x.price.info.price,
            quantity: x.price.info.quantity,
            value: x.info.subject
          }] : []
          const pIdItemsPrices = pIdItemsPrice(pIdItems)
          const pIdInfo = pIdItems.length > 0 // 페이지 submit에는 이미 pIdInfo 데이터가 있기 때문에 override 하지 않음
            ? {
              price: {
                net: priceInfo.total - pIdItemsPrices, // 본 상품 가격
                sum: pIdItemsPrices, // pId items 합계
                total: priceInfo.total, // 총합계
                ...this.tax && {
                  subtotal: priceInfo.subtotal,
                  tax: priceInfo.tax
                }
              },
              items: pIdItems
            } : null
          return x.submitId === 'system_amenity'
            ? submitAmenity
              ? {
                ...submitAmenity,
                items: submitAmenityItems
              }
              : null
            : {
              ...x,
              title: x.title,
              pId: x.pId || null,
              cartId: x.cartId || null,
              pageId: x.pageId || null,
              productId: x.productId || null,
              productItemId: x.productItemId || null,
              submitAt: moment().toISOString(),
              submitId: x.submitId,
              catCode: x.submitId,
              info: x.info,
              categoryLabel: x.categoryLabel || null,
              content: x.submitContent,
              price: {
                ...x.price,
                info: {
                  ...x.price.info,
                  quantity: x.changedInfo ? x.changedInfo.qty : x.price.info.quantity,
                  total: x.changedInfo ? x.changedInfo.total : x.price.info.total
                }
              },
              ...(submitAmenityV2 && x.submitId === 'system_amenity_v2') && {
                content: submitAmenityV2List,
                items: submitAmenityV2List
              },
              ...x.place && {
                place: x.place,
                placeName: x.place[lang]
              },
              ...x.pickup && {
                pickup: x.pickup,
                ...x.pickup === 'auto' && {
                  pickupTime: x.pickupTime
                }
              },
              ...pIdInfo && {
                pIdInfo: pIdInfo,
              }
            }
        })
      const submitDataAll = shopPageId ? [] : submitIds.map(id => {
        return {
          isArray: true,
          submitId: id,
          submitArr: submitDataList.filter(x => x.submitId === id).concat([submitAmenityList])
        }
      })
      function pIdItemsPrice (arr) {
        return arr.filter(x => x.price).map(x => {
          const quantity = x.quantity || 1
          const price = x.price || 0
          return price * quantity
        }).reduce((a, b) => a + b, 0)
      }

      if (shopIds && shopIds.length) {
        /**
         * shopPageId(shopCode) billing 체크
         * pos연동되는 shopItem인 경우 빌링이 끝나면 해당 ota로는 더이상 주문을 할 수 없게 하고(ota reset)
         * 새로운 ota로 갱신하여 주문이 들어가야 한다
         * 빌링 - 포스 결제
         */
        this.$store.commit('loading', true)
        const checkOrderStatus = await this.checkOrderStatus()
        if (checkOrderStatus) {
          if (checkOrderStatus.newOTAKey) {
            await this.$store.dispatch('authentication/getOtaKey', true)
          }
          const res = await this.submitShopItems()
          if (!res) {
            this.delToast()
            this.$store.commit('loading', false)
            return null
          }
        } else {
          this.delToast()
          this.$store.commit('loading', false)
          return null
        }
      }
      this.$store.dispatch('submit/getSubmitCode').then((res) => {
        const systemCode = res[0] || []
        const userCode = res[1] || []
        const submitCode = systemCode.concat(userCode).map(x => x.id)
        const submitData = submitDataList.filter(x => submitCode.includes(x.submitId))
        const isFrame = this.isPublic ? '&frame=false' : ''
        const remainItems = !this.multiCart && submitData.find(x => x.cartId.includes('amenity')) ? `&remainAmenity=true` : ''
        const returnURL = `${window.location.origin}${window.location.pathname}${window.location.search}${isFrame}${remainItems}#/${lang}/complete`
        const totalPrice = typeof (submitId) === 'string' ? this.totalPrice(submitId) : this.totalPrice()
        const taxPrice = typeof (submitId) === 'string' ? this.taxPrice(submitId) : this.taxPrice()
        const submit = {
          isArray: true,
          payload: shopPageId ? [] : submitData,
          returnURL: returnURL,
          price: {
            info: {
              ...typeof (submitId) === 'string' ? this.priceInfo(submitId) : this.priceInfo(),
              total: totalPrice,
              ...taxPrice
            },
            total: taxPrice && taxPrice.total ? taxPrice.total : totalPrice
          }
        }
        // 삭제되거나 유효하지 않은 전송코드가 있는 경우
        if (submitDataAll.filter(x => !submitCode.includes(x.submitId)).length) {
          // '유효하지 않은 전송코드가 있습니다.\n해당 건을 제외하고 진행합니다.'
          const uncheckedIds = this.cartList.filter(x => x.isChecked && !submitCode.includes(x.submitId)).map(x => x.cartId)
          this.addToast('closeToast', 'alert', `${this.locale.cart_invalid_catcode_1}\n${this.locale.cart_invalid_catcode_2}`)
          this.list = this.list.map(x => {
            return {
              ...x,
              isChecked: !uncheckedIds.includes(x.cartId) ? x.isChecked : false
            }
          })
        }
        // shop상품만 전송한 경우 더이상 진행할 필요가 없음
        if (submit.payload && submit.payload.length <= 0) {
          this.deleteCart(this.checkedIds)
          this.delToast()
          this.$emit('complete', this.locale.complete_request)
          this.$store.commit('loading', false)
          return null
        }
        this.$store.dispatch('submit/setSubmit', submit).then((res) => {
          this.$emit('complete')
          this.delToast()
          /**
           * 결제 연동된 사이트의 경우
           * 결제 프로세스 진행
           */
          if (res && res.status && res.status === 200) {
            // siteInfo.commerce인 경우 결제과정 거친 후 center로 요청
            // 결제중에서도 후불결제(룸차지)를 허용하는 경우 결제방식 선택 페이지로 이동
            const payment = res.payment
            if (payment) {
              const paymentId = res.paymentId
              // const routerName = res.roomCharge ? 'paymentStep' : 'payment'
              const routerName = 'paymentStep'
              const cartIds = typeof (submitId) === 'string' ? this.list.filter(x => x.submitId === submitId).map(x => x.cartId) : this.checkedIds
              this.$router.push({
                name: routerName,
                params: {
                  ln: lang,
                  payment: payment,
                  paymentId: paymentId,
                  ...routerName === 'paymentStep' && {
                    cartIds: cartIds
                  }
                }
              })
              this.$store.commit('loading', false)
            } else {
              // center로 바로 요청
              if (submit.payload.find(x => x.cartId.includes('amenity'))) {
                this.$store.dispatch('submit/setSubmit', submitAmenityList)
              }
              this.deleteCart(typeof (submitId) === 'string'
                ? this.list.filter(x => x.submitId === submitId).map(x => x.cartId)
                : shopPageId
                  ? this.list.filter(x => x.shopPageId === shopPageId).map(x => x.cartId)
                  : this.checkedIds
              )
              this.addToast('closeToast', 'alert', this.locale.complete_request)
              this.$router.push({ name: 'complete', params: { lang: lang } })
              // this.$store.commit('loading', false)
            }
          } else {
            if (res.message && res.message.length) {
              if (res.message.includes('Unauthorized')) {
                // 유효하지 않은 인증키입니다.
                alert(this.locale.invalid_key)
                window.location.reload()
              } else if (res.message.includes('amount')) {
                // 결제할 수 없는 금액입니다.
                alert(this.locale.alert_amount_cannot_paid)
              } else if (res.message.includes('currency')) {
                // 지원하지 않는 통화입니다.
                alert(this.locale.alert_currency_not_support)
              } else {
                // 시스템에러가 발생했습니다.
                alert(this.locale.alert_system_error)
              }
            } else {
              // 시스템에러가 발생했습니다.
              alert(this.locale.alert_system_error)
            }
            this.delToast()
            this.$store.commit('loading', false)
          }
          // this.$store.commit('loading', false)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.noData {
  padding: 90px 0;
  justify-content: center;
}
.total {
  font-size: 0.9em;
  .count {
    display: inline-block;
    margin-left: 0.3em;
    padding: 0 0.5em;
    font-size: 0.9em;
    font-weight: 700;
    color: $color-white;
    line-height: 1.3;
    border-radius: 50px;
    background-color: $color-green;
  }
}
.validateMessage {
  margin-bottom: 2px;
  padding: 2px 0;
  text-align: center;
  white-space: nowrap;
  color: $color-white;
  border-radius: 20px;
  background-color: $color-red;
}
</style>
